import { differenceInDays, format } from "date-fns";
import React from "react";
import {
  pdf,
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
  Font,
  PDFViewer,
} from "@react-pdf/renderer";
import ReactDOMServer from "react-dom/server";
import Html from "react-pdf-html";
import classNames from "classnames";
import moment from "moment";
import numeral from "numeral";
import {
  Table,
  TableBody,
  TableCell,
  TableHeader,
  DataTableCell,
} from "@david.kucsai/react-pdf-table";
import { pad } from "utils/getLocalDateTime";
import { calcuratorInterestTwo } from "../../utils/reinstallments";
import { reinstallments } from "utils/reinstallments";
import { months } from "utils/getLocalDateTime";
import { getValueAccountStatus } from "utils/buro";
import ImageStatus from "./รหัสและสถานะบัญชี.pdf";
import { getValueInstallmentAmount } from "utils/buro";
import { getValueAmountOwed } from "utils/buro";
import { getAmountPastDue } from "utils/buro";
import { getCurrentLocalDateTime } from "utils/getLocalDateTime";
import _ from "lodash";
import { getDetailSegment } from "utils/buro";
import { getNumberTwoDecimal } from "../Leasing/utils/leasing.u";

Font.register({
  family: "Sarabun",
  fonts: [
    { src: "/fonts/Sarabun-Regular.ttf" },
    { src: "/fonts/Sarabun-Bold.ttf" },
  ],
});

const getDateStr = (dateStr) => {
  if (!dateStr || dateStr === "19000101") return "-";
  const year = dateStr.slice(0, 4);
  const month = dateStr.slice(4, 6);
  const date = dateStr.slice(6, 8);
  return `${date}-${month}-${+year + 543}`;
};

const getOverDueDate = (overdue_date) => {
  if (!overdue_date) return "-";

  const diff_days = differenceInDays(new Date(), new Date(overdue_date));
  return diff_days > 0 ? diff_days : 0;
};

const getCountString = (count) => {
  let newCount = count.toString();
  let prefix = 10 - newCount.length;
  for (let i = 0; i < prefix; i++) newCount = "0" + newCount;
  return newCount;
};

const PdfDocument = ({ letter_id, isFirst = false, row, index }) => {
  var now_th = moment.locale("th");
  var today = moment().add(543, "year").format("DD/MM/YYYY");
  var currentYear = moment().add(543, "year").year();
  var rawMonth = moment().format("MM");
  var currentMonth = "มกราคม";
  if (rawMonth == "02") currentMonth = "กุมภาพันธ์";
  if (rawMonth == "03") currentMonth = "มีนาคม";
  if (rawMonth == "04") currentMonth = "เมษายน";
  if (rawMonth == "05") currentMonth = "พฤษภาคม";
  if (rawMonth == "06") currentMonth = "มิถุนายน";
  if (rawMonth == "07") currentMonth = "กรกฎาคม";
  if (rawMonth == "08") currentMonth = "สิงหาคม";
  if (rawMonth == "09") currentMonth = "กันยายน";
  if (rawMonth == "10") currentMonth = "ตุลาคม";
  if (rawMonth == "11") currentMonth = "พฤศจิกายน";
  if (rawMonth == "12") currentMonth = "ธันวาคม";

  var previousYear = Number(currentYear) - 1;
  var header = "หนังสือแจ้งรายปี";
  if (isFirst) {
    header = "หนังสือแจ้งครั้งแรกฉบับที่";
  }

  return (
    <Document>
      {/* <Page size="A4" style={stylesDocument.page}> */}
      <Text style={stylesDocument.header}>
        หนังสือแจ้งให้ลูกค้าทราบเกี่ยวกับการส่งข้อมูลให้แก่บริษัทข้อมูลเครดิต (
        {header})
        {/* {(new Date().getFullYear() + 543).toString() +
          "/" +
          getCountString(+letter_id + index + 1)}
        ) */}
      </Text>
      <View style={stylesDocument.betweenLine}></View>
      <View style={stylesDocument.betweenLine}></View>
      <Text style={stylesDocument.date}>วันที่ {today}</Text>
      <View style={stylesDocument.betweenLine}></View>
      <Text>เรียน คุณ {row.fullname}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</Text>
      <View style={stylesDocument.newLine}></View>
      <Text style={stylesDocument.marginLeft}>
        ตามพระราชบัญญัติการประกอบธุรกิจข้อมูลเครดิต พ.ศ. 2545
        และที่แก้ไขเพิ่มเติม และประกาศคณะกรรมการ
      </Text>
      <View style={stylesDocument.betweenLine}></View>
      <Text>
        คุ้มครองข้อมูลเครดิต กำหนดให้{" "}
        <Text style={stylesDocument.bold}>
          บริษัท มันนี่ ฮับ เซอร์วิส จำกัด
        </Text>{" "}
        มีหน้าที่ต้องส่งข้อมูลเครดิตของท่านให้แก่ บริษัท
      </Text>
      <View style={stylesDocument.betweenLine}></View>
      <Text>
        ข้อมูลเครดิตแห่งชาติ จำกัด ที่{" "}
        <Text style={stylesDocument.bold}>
          บริษัท มันนี่ ฮับ เซอร์วิส จำกัด
        </Text>{" "}
        เป็นสมาชิกอยู่ และแจ้งให้ท่านทราบเกี่ยวกับข้อมูล
      </Text>
      <View style={stylesDocument.betweenLine}></View>
      <Text>
        เครดิตที่ส่งไปดังกล่าว ดังนั้น
        เพื่อดำเนินการให้เป็นไปตามบทบัญญัติของพระราชบัญญัติ ตลอดจนประกาศคณะ{" "}
      </Text>
      <View style={stylesDocument.betweenLine}></View>
      {!isFirst && (
        <View>
          <Text>
            กรรมการคุ้มครอง ข้อมูลเครดิตข้างต้น{" "}
            <Text style={stylesDocument.bold}>
              บริษัท มันนี่ ฮับ เซอร์วิส จำกัด{" "}
            </Text>
            จึงขอแจ้งให้ท่านทราบว่า ในรอบปี ({previousYear}/
          </Text>
          <View style={stylesDocument.betweenLine}></View>
          <Text>
            {currentYear}) ที่ผ่านมา ได้ส่ง ข้อมูลเครดิตของท่าน ให้แก่ บริษัท
            ข้อมูลเครดิตแห่งชาติ จำกัด แล้ว โดยข้อมูลเครดิตที่{" "}
          </Text>
          <View style={stylesDocument.betweenLine}></View>
          <Text>
            <Text style={stylesDocument.bold}>
              บริษัท มันนี่ ฮับ เซอร์วิส จำกัด{" "}
            </Text>
            ส่งไปดังกล่าว มีรายละเอียด ปรากฎท้ายหนังสือนี้{" "}
          </Text>
        </View>
      )}
      {isFirst && (
        <View>
          <Text>
            กรรมการคุ้มครอง ข้อมูลเครดิตข้างต้น{" "}
            <Text style={stylesDocument.bold}>
              บริษัท มันนี่ ฮับ เซอร์วิส จำกัด{" "}
            </Text>
            จึงขอแจ้งให้ท่านทราบว่า ใน{" "}
            <Text style={stylesDocument.bold}>เดือน {currentMonth}</Text>
          </Text>
          <View style={stylesDocument.betweenLine}></View>
          <Text>
            <Text style={stylesDocument.bold}>
              ปี {currentYear} บริษัท มันนี่ ฮับ เซอร์วิส จำกัด
            </Text>{" "}
            ได้ส่งข้อมูลเครดิตของท่าน ณ{" "}
            <Text style={stylesDocument.bold}>
              เดือน {currentMonth} ปี {currentYear}
            </Text>{" "}
            ให้แก่ บริษัท
          </Text>
          <View style={stylesDocument.betweenLine}></View>
          <Text>
            ข้อมูลเครดิตแห่งชาติ จำกัด แล้ว โดยข้อมูลเครดิตที่{" "}
            <Text style={stylesDocument.bold}>
              บริษัท มันนี่ ฮับ เซอร์วิส จำกัด
            </Text>
            {isFirst ? " ส่งไปดังกล่าว มีรายละเอียด" : ""}
          </Text>
          <View style={stylesDocument.betweenLine}></View>
          <Text> ส่งไปดังกล่าว มีรายละเอียด ปรากฎท้ายหนังสือนี้ </Text>
        </View>
      )}

      <View style={stylesDocument.betweenLine}></View>
      <View style={stylesDocument.betweenLine}></View>
      <View style={stylesDocument.betweenLine}></View>
      <View style={stylesDocument.betweenLine}></View>
      <View style={stylesDocument.betweenLine}></View>
      <Text style={stylesDocument.marginLeft}>
        {" "}
        ทั้งนี้ ข้อมูลเครดิตที่{" "}
        <Text style={stylesDocument.bold}>
          บริษัท มันนี่ ฮับ เซอร์วิส จำกัด
        </Text>{" "}
        นำส่งให้แก่ บริษัท ข้อมูลเครดิตแห่งชาติ จำกัด{" "}
      </Text>
      <View style={stylesDocument.betweenLine}></View>
      <Text>
        ดังกล่าว{" "}
        <Text style={stylesDocument.red}>
          {isFirst ? "แสดงรายละเอียดการชำระสินเชื่อ" : "ประวัติการชำระสินเชื่อ"}
        </Text>{" "}
        ที่ท่านมีกับ{" "}
        <Text style={stylesDocument.bold}>
          บริษัท มันนี่ ฮับ เซอร์วิส จำกัด
        </Text>{" "}
        เพียงสถานะล่าสุดในขณะที่{" "}
      </Text>
      <View style={stylesDocument.betweenLine}></View>
      <Text>
        <Text style={stylesDocument.bold}>
          บริษัท มันนี่ ฮับ เซอร์วิส จำกัด
        </Text>{" "}
        จัดทำข้อมูลเพื่อนำส่งข้อมูลเครดิตให้แก่ บริษัท ข้อมูลเครดิตแห่งชาติ
        จำกัด{" "}
      </Text>
      <View style={stylesDocument.betweenLine}></View>
      <Text>
        ดังกล่าวเท่านั้น ซึ่งข้อมูลเครดิตดังกล่าวอาจแตกต่างจากข้อมูลที่{" "}
        <Text style={stylesDocument.bold}>
          บริษัท มันนี่ ฮับ เซอร์วิส จำกัด
        </Text>{" "}
        มีอยู่ในขณะนี้
      </Text>
      <View style={stylesDocument.newLine}></View>

      <Text style={stylesDocument.marginLeft}>
        จึงเรียนมาเพื่อโปรดทราบ หากท่านมีข้อสงสัย หรือข้อสอบถาม โปรด
      </Text>
      <View style={stylesDocument.betweenLine}></View>
      <Text>
        ติดต่อ{" "}
        <Text style={stylesDocument.bold}>
          บริษัท มันนี่ ฮับ เซอร์วิส จำกัด
        </Text>{" "}
        โทรศัพท์ 02-821-6710
      </Text>
      <View style={stylesDocument.newLine}></View>
      <Text style={stylesDocument.end}>ขอแสดงความนับถือ</Text>
      <View style={stylesDocument.betweenLine}></View>
      <View style={stylesDocument.betweenLine}></View>
      <Text style={stylesDocument.signature}>
        บริษัท มันนี่ ฮับ เซอร์วิส จำกัด
      </Text>
      {/* </Page> */}
    </Document>
  );
};

const stylesInstallment = StyleSheet.create({
  page: {
    fontFamily: "Cordia New",
    padding: 10,
    fontSize: 14,
    backgroundColor: "#fff",
  },
  flex: {
    display: "flex",
  },
  viewHeader: {
    marginTop: "16px",
    paddingLeft: "40px",
    paddingRight: "40px",
  },
  border: {
    border: "1px solid #000",
    padding: "4px",
  },
  textType: {
    border: "1px solid #000",
    padding: "4px 4px 4px 8px",
    width: "75px",
    fontSize: "10px",
  },
  textHeader: {
    textAlign: "center",
    fontSize: 12,
    marginBottom: "16px",
    fontWeight: "bold",
  },
  bold: {
    fontSize: 10,
    fontWeight: 500,
  },
  spaceX: {
    marginLeft: "18px",
    marginRight: "18px",
  },
  text: {
    fontSize: 10,
  },
  section: {
    marginTop: "36px",
    marginLeft: "42px",
  },
  space: {
    margin: "2px",
  },
  installment: {
    display: "flex",
    marginTop: "16px",
  },
});

const getInstallments = ({ data, buroYear, interest }) => {
  const month = 12;
  const newInstallments = [];
  let accountStatus = "";
  let cloneData = data;

  for (let i = 0; i < month; i++) {
    const monthOfIndex = months[i];
    const splitRequestTime = cloneData?.requestTimeFullDate?.split("-");
    const monthRequestTime = splitRequestTime[1];
    // const buroDate =
    //   i === 0 && monthRequestTime === "12"
    //     ? `${buroYear?.value}-12-31`
    //     : `${buroYear?.value}-${pad(i + 1)}-${monthOfIndex.days}`;
    const buroDate = `${buroYear?.value}-${pad(i + 1)}-${monthOfIndex.days}`;
    const buroMonth = `${pad(i + 1)}-${buroYear?.value}`;

    if (cloneData?.loan_kbank_id === "400170943") {
      cloneData.evidence[cloneData.evidence.length - 1].paid_amount = 85
    }

    let newLoan = _.cloneDeep(reinstallments(cloneData, buroDate, interest));
    let isLastPaymentDone = false
    if (cloneData?.evidence?.length > 0) {
      const lastEvidence =
        cloneData?.evidence[cloneData?.evidence.length - 1];
      const splitDate = lastEvidence?.paid_date?.split("-");
      const monthDate = splitDate[1];
      const yearDate = splitDate[0];
      const paidDate = `${monthDate}-${yearDate}`;
      if (cloneData.loan_status === "DONE" && paidDate === buroMonth) {
        newLoan = cloneData;
        isLastPaymentDone = true;
      }
    }

    const calNewLoan = _.cloneDeep(
      calcuratorInterestTwo(
        { ...cloneData, ...newLoan },
        {
          where: { paid_date: buroDate },
          dataInterest: interest,
        }
      )
    );

    const includeLoan = _.cloneDeep({
      ...calNewLoan,
      original: { ...cloneData },
    });

    const findInstallmentOfMonth = includeLoan.installments.find(
      (installment) => {
        const [year, month, days] = installment.date.split("-");

        if (String(year) === String(buroYear?.value)) {
          const installmentDate = `${month}-${year}`;
          let checkDate = buroMonth === installmentDate;
          // (i === 0 && monthRequestTime === "12");
          if (checkDate) {
            return installment;
          }
        }
      }
    );

    // if (buroMonth === "01-2024" || buroMonth === "02-2024") {
    //   console.log("cloneData", cloneData);
    //   console.log("findInstallmentOfMonth", findInstallmentOfMonth);
    //   console.log("accountStatus", accountStatus);
    //   console.log("buroMonth", buroMonth);
    //   console.log("includeLoan", includeLoan);
    // }

    if (!findInstallmentOfMonth || String(accountStatus) === "11") {
      const lastInstallment = includeLoan?.installments[includeLoan?.installments.length - 1];
      const status = getValueAccountStatus({
        data: includeLoan,
        currentDate: buroDate,
      });
      if (includeLoan?.capitalRemain <= 0 && lastInstallment?.actualInterest > 0) {
        newInstallments.push({
          displayYear: `${pad(i + 1)}/${buroYear?.value + 543}`,
          initCapital: includeLoan.initCapital,
          capitalRemain: getValueAmountOwed({
            data: includeLoan,
            currentDate: buroDate,
          }),
          payment: getAmountPastDue({
            data: includeLoan,
            currentDate: buroDate,
          }),
          status: includeLoan?.loan_status === "DONE" ? "11" : status,
        });
      } else if (includeLoan.loan_status === "DONE" && isLastPaymentDone) {
        newInstallments.push({
          displayYear: `${pad(i + 1)}/${buroYear?.value + 543}`,
          initCapital: "",
          capitalRemain: "",
          payment: "",
          status: "11",
        });
      } else {
        newInstallments.push({
          displayYear: `${pad(i + 1)}/${buroYear?.value + 543}`,
        initCapital: "",
        capitalRemain: "",
        payment: "",
        status: "",
      });
      }
       
    } else {
      const status = getValueAccountStatus({
        data: includeLoan,
        currentDate: buroDate,
      });
      newInstallments.push({
        displayYear: `${pad(i + 1)}/${buroYear?.value + 543}`,
        initCapital: includeLoan.initCapital,
        capitalRemain: getValueAmountOwed({
          data: includeLoan,
          currentDate: buroDate,
        }),
        payment: getAmountPastDue({
          data: includeLoan,
          currentDate: buroDate,
        }),
        // findInstallmentOfMonth?.actualInterest +
        // findInstallmentOfMonth?.actualPrinciple,
        status: includeLoan?.loan_status === "DONE" ? "11" : status,
      });
      accountStatus = status;
    }

    console.log("-".repeat(100));
  }
  return newInstallments;
};

const PdfInstallment = ({ data, buroYear, interest }) => {
  return (
    <html>
      <body>
        <style>
          {`
            *{
              font-family: Sarabun;
            }
            .wrapper_report{
              font-size: 14px;
             
              text-align: center;
              margin-top: 15px;
              color: #0000FF;
            }

            .wrapper_report_detail{
              margin-top: 22px;
            }

            .text-blue{
              color: #0000FF;
            }

            .border{
              border: 1px solid #000;
              padding: 5px 7px;
            }

            .clear-border-bottom {
              border-bottom: 0px solid #000;
            }

            .title{
              display: flex;
              font-size: 12px;
              width: 90px;
            }

            .desc{
              display: flex;
              flex-direction: row;
              font-size: 10px;
              margin-top: 8px;
              margin-left: 4px;
              width: 50%;
            }

            .desc-address{
              display: flex;
              flex-direction: row;
              font-size: 10px;
              margin-top: 8px;
              margin-left: 4px;
              width: 100%;
            }

            .desc-two{
              display: flex;
              justify-content: space-between;
              flex-direction: row;
            }

            .desc-right{
              display: flex;
              font-size: 10px;
              margin-left: 2px;
            }

            .desc-right-two{
              display: flex;
              margin-right: auto;
              width: 50%;
            }

            .wrapper_report_detail_footer {
              margin-top: 15px;
            }

            .wrapper_report_footer {
              margin-top: 50px;
              display: flex;
              flex-direction: row;
              justify-content: space-between;
            }
            
            .text-footer-left{
              color: #FF4500;
              text-decoration: underline;
              width: 8%;
            }

            .text-footer-right{
              color: #FF4500;
              width: 92%;
            }

            .text-footer-justify{
              text-align: justify;
            }

            .text-footer-right-margin{
              margin-top: 4px;
            }

            .text-footer{
              font-size: 10px;
            }
          }`}
        </style>
        <div className="wrapper_report border">
          หนังสือแจ้งข้อมูลเครดิตที่รายงาน บริษัท ข้อมูลเครดิตแห่งชาติ จำกัด{" "}
        </div>
        <div className="wrapper_report_detail">
          <div className="title text-blue border clear-border-bottom">
            ประเภทลูกค้า{" "}
          </div>
          <div className="title text-blue border">ข้อมูลทั่วไป </div>
          <div className="desc-two">
            <div className="desc">
              <div>ชื่อเจ้าของข้อมูล : </div>
              <div className="desc-right text-blue">
                {data?.article || ""} {data?.fullname}
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              </div>
            </div>
            <div className="desc desc-right-two">
              <div>วันเดือนปีเกิด : </div>
              <div className="desc-right text-blue">{data.birthdateTh} </div>
            </div>
          </div>
          <div className="desc">
            <div>เลขที่บัตรประชาชน : </div>
            <div className="desc-right text-blue"> {data?.citizenid} </div>
          </div>
          <div className="desc-address">
            <div>ที่อยู่ : </div>
            <div className="desc-right text-blue">
              {data.addressCode + " " + data.addressDesc + " " + data.address}
              {/* {data?.address_1?.value}&nbsp;{data?.address_2?.value}{" "} */}
            </div>
          </div>
          <div className="desc-two">
            <div className="desc">
              <div>เลขที่สัญญาผู้กู้ : </div>
              <div className="desc-right text-blue">{data?.loan_kbank_id}</div>
            </div>
            <div className="desc">
              <div>ประเภทสินเชื่อ : </div>
              <div className="desc-right text-blue">{data?.type}</div>
            </div>
          </div>
          <div className="desc-two">
            <div className="desc">
              <div>วันที่ผิดนัดชำระหนี้ : </div>
              <div className="desc-right text-blue">
                {data?.loan_status !== "DONE" &&
                differenceInDays(new Date(), new Date(data?.overdue_date)) > 0
                  ? data?.overdue_date
                  : "-"}
              </div>
            </div>
            <div className="desc">
              <div>ยอดชำระในแต่ละงวด : </div>
              <div className="desc-right text-blue">
                {numeral(data?.payPerMonth).format("0,000")}
              </div>
            </div>
          </div>
        </div>
        <div className="wrapper_report_detail_footer">
          <table style={{ border: "1px solid #000" }}>
            <thead>
              <tr>
                <th
                  style={{
                    textAlign: "center",
                    fontSize: "12px",
                    padding: "2px 4px",
                  }}
                  colSpan={5}
                >
                  {" "}
                  ข้อมูลประวัติการชำระสินเชื่อ
                </th>
              </tr>
              <tr>
                <th
                  style={{
                    textAlign: "center",
                    fontSize: "10px",
                    padding: "2px 4px",
                  }}
                >
                  {" "}
                  ข้อมูล ณ เดือนปี{" "}
                </th>
                <th
                  style={{
                    textAlign: "center",
                    fontSize: "10px",
                    padding: "2px 4px",
                  }}
                >
                  {" "}
                  ยอดกู้ทั้งหมด{" "}
                </th>
                <th
                  style={{
                    textAlign: "center",
                    fontSize: "10px",
                    padding: "2px 4px",
                  }}
                >
                  {" "}
                  ยอดคงเหลือ{" "}
                </th>
                <th
                  style={{
                    textAlign: "center",
                    fontSize: "10px",
                    padding: "2px 4px",
                  }}
                >
                  {" "}
                  ยอดหนี้ที่เกินกำหนดชําระ{" "}
                </th>
                <th
                  style={{
                    textAlign: "center",
                    fontSize: "10px",
                    padding: "2px 4px",
                  }}
                >
                  {" "}
                  สถานะบัญชี{" "}
                </th>
              </tr>
            </thead>
            <tbody>
              {getInstallments({ data, buroYear, interest })?.length > 0 &&
                getInstallments({ data, buroYear, interest })?.map(
                  (installment, index) => {
                    return (
                      <tr>
                        <td
                          style={{
                            textAlign: "center",
                            fontSize: "12px",
                            padding: "2px 4px",
                          }}
                        >
                          {installment?.displayYear}
                        </td>
                        <td
                          style={{
                            textAlign: "center",
                            fontSize: "12px",
                            padding: "2px 4px",
                          }}
                        >
                          {numeral(installment?.initCapital).format("0,000")}
                        </td>
                        <td
                          style={{
                            textAlign: "center",
                            fontSize: "12px",
                            padding: "2px 4px",
                          }}
                        >
                          {numeral(installment?.capitalRemain).format("0,000")}
                        </td>
                        <td
                          style={{
                            textAlign: "center",
                            fontSize: "12px",
                            padding: "2px 4px",
                          }}
                        >
                          {numeral(installment?.payment).format("0,000")}
                        </td>
                        <td
                          style={{
                            textAlign: "center",
                            fontSize: "12px",
                            padding: "2px 4px",
                          }}
                        >
                          {installment?.status}
                        </td>
                      </tr>
                    );
                  }
                )}
            </tbody>
          </table>
        </div>
        <div className="wrapper_report_footer">
          <div className="text-footer-left text-footer">หมายเหตุ </div>
          <div className="text-footer text-footer-right">
            <div className="text-footer-justify">
              จำนวนเงินที่แสดงในรายงานข้อมูลเครดิตเป็นเพียงจํานวนเงินที่เป็นไปตามหลักเกณฑ์การนําส่งข้อมูลตามพระราชบัญญัติ&nbsp;
            </div>
            <div className="text-footer-right-margin text-footer-justify">
              การประกอบธุรกิจข้อมูลเครดิต พ.ศ. {buroYear?.value + 543}{" "}
              และที่แก้ไขเพิ่มเติม
              และประกาศคณะกรรมการคุ้มครองข้อมูลเครดิตเท่านั้น&nbsp;
            </div>
            <div className="text-footer-right-margin text-footer-justify">
              ทั้งนี้อาจแตกต่างกับยอดหนี้คงค้างที่สถาบันการเงินมีสิทธิเรียกร้องตามสัญญา
              และหรือตามที่กฎหมายกำหนด&nbsp;
            </div>
            <div className="text-footer-right-margin text-footer-justify">
              ซึ่งควรตรวจสอบข้อมูลเพิ่มเติมจากสถาบันการเงินก่อนทุกครั้ง&nbsp;
            </div>
          </div>
        </div>
      </body>
    </html>
  );
};

const stylesDocument = StyleSheet.create({
  page: {
    fontFamily: "Sarabun",
    padding: 26,
    fontSize: 12,
    backgroundColor: "#fff",
  },
  bold: {
    fontFamily: "Sarabun",
    fontWeight: "bold",
  },
  date: {
    textAlign: "right",
  },
  newLine: {
    marginTop: 32,
  },
  marginLeft: {
    marginLeft: 20,
  },
  betweenLine: {
    marginTop: 4,
  },
  header: {
    fontSize: 11,
    textAlign: "center",
  },
  red: {
    color: "red",
  },
  end: {
    textAlign: "right",
    marginRight: 32,
  },
  signature: {
    textAlign: "right",
    marginRight: 16,
    fontWeight: "bold",
  },
});

const PdfStatus = () => {
  return (
    <html>
      <body>
        <style>
          {`
            *{
              font-family: Sarabun;
            }
            .wrapper_report{
              font-size: 14px;
             
              text-align: center;
              margin-top: 15px;
              color: #0000FF;
            }

            .wrapper_report_detail{
              margin-top: 22px;
            }

            .text-blue{
              color: #0000FF;
            }

            .border{
              border: 1px solid #000;
              padding: 5px 7px;
            }

            .clear-border-bottom {
              border-bottom: 0px solid #000;
            }

            .title{
              display: flex;
              font-size: 12px;
              width: 90px;
            }

            .desc{
              display: flex;
              flex-direction: row;
              font-size: 10px;
              margin-top: 8px;
              margin-left: 4px;
              width: 50%;
            }

            .desc-address{
              display: flex;
              flex-direction: row;
              font-size: 10px;
              margin-top: 8px;
              margin-left: 4px;
              width: 100%;
            }

            .desc-two{
              display: flex;
              justify-content: space-between;
              flex-direction: row;
            }

            .desc-right{
              display: flex;
              font-size: 10px;
              margin-left: 2px;
            }

            .desc-right-two{
              display: flex;
              margin-right: auto;
              width: 50%;
            }

            .wrapper_report_detail_footer {
              margin-top: 15px;
            }

            .wrapper_report_footer {
              margin-top: 50px;
              display: flex;
              flex-direction: row;
              justify-content: space-between;
            }
            
            .text-footer-left{
              color: #FF4500;
              text-decoration: underline;
              width: 8%;
            }

            .text-footer-right{
              color: #FF4500;
              width: 92%;
            }

            .text-footer-justify{
              text-align: justify;
            }

            .text-footer-right-margin{
              margin-top: 4px;
            }

            .text-footer{
              font-size: 10px;
            }
          }`}
        </style>
        <div className="wrapper_report_detail_footer">
          <table style={{ border: "1px solid #000" }}>
            <thead>
              <tr>
                <th
                  style={{
                    textAlign: "center",
                    fontSize: "12px",
                    padding: "2px 4px",
                  }}
                  colSpan={2}
                >
                  {" "}
                  ตารางรหัสสถานะบัญชี
                </th>
              </tr>
              <tr>
                <th
                  style={{
                    textAlign: "center",
                    fontSize: "12px",
                    padding: "2px 4px",
                  }}
                >
                  รหัสสถานะบัญชี
                </th>
                <th
                  style={{
                    textAlign: "center",
                    fontSize: "12px",
                    padding: "2px 4px",
                  }}
                >
                  ความหมายของรหัสสถานะบัญชี
                </th>
              </tr>
            </thead>
            <tbody>
              {[
                ["10 หรือ 010", "บัญชีปกติ "],
                ["11 หรือ 011", "ปิดบัญชี "],
                ["12 หรือ 012", "พักชำระหนี้ตามนโยบายของสมาชิก "],
                ["13 หรือ 013", "พักชำระหนี้ตามนโยบายของรัฐ "],
                ["14 หรือ 014", "พักชำระหนี้เกษตรกรตามนโยบายของรัฐ "],
                ["20 หรือ 020", "หนี้ค้างชำระเกิน 90 วัน "],
                [
                  "21 หรือ 021",
                  "หนี้ค้างชำระเกิน 90 วัน เนื่องจากหนี้ได้รับผลกระทบจากสถานการณ์ที่ไม่ปกติ ",
                ],
                ["30 หรือ 030", "อยู่ในกระบวนการทางกฎหมาย "],
                ["31 หรือ 031", "อยู่ในระหว่างชำระหนี้ตามคำพิพากษา "],
                [
                  "32 หรือ 032",
                  "ศาลพิพากษายกฟ้องเนื่องจากขาดอายุความ\nหรือเหตุอื่นเว้นแต่ยกฟ้อง\nเนื่องจากความเป็นหนี้มิได้มีอยู่จริง ",
                ],
                ["33 หรือ 033", "ปิดบัญชีเนื่องจากตัดหนี้สูญ "],
                ["40 หรือ 040", "อยู่ระหว่างชำระสินเชื่อปิดบัญชี "],
                ["41 หรือ 041", "อยู่ระหว่างการตรวจสอบรายการ "],
                ["42 หรือ 042", "โอนหรือขายหนี้ที่ค้างชำระเกิน 90 วัน "],
                ["43 หรือ 043", "โอนหรือขายหนี้และชำระหนี้เสร็จสิ้น "],
                ["44 หรือ 044", "โอนหรือขายหนี้ที่เป็นสถานะบัญชีปกติ "],
              ].map((row, rowIndex) => {
                return (
                  <tr key={rowIndex}>
                    {row.map((col, colIndex) => {
                      return (
                        <td
                          key={colIndex}
                          style={{
                            textAlign: "center",
                            fontSize: "10px",
                            padding: "4px 0px",
                            lineHeight: "1.5",
                            // wordBreak: "break-all",
                          }}
                        >
                          {rowIndex === 8 && colIndex === 1 ? (
                            <div>
                              อยู่ในระหว่างชำระหนี้ตามพิพากษาตามยอม&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            </div>
                          ) : (
                            col
                          )}
                        </td>
                      );
                    })}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </body>
    </html>
  );
};

var isProcessing = false;

function PdfBuroYear({
  data,
  letter_id = "1",
  index = 0,
  buroYear,
  interest,
  // s3Status,
}) {
  const getHtmlInstallment = () => {
    const html = ReactDOMServer.renderToStaticMarkup(
      PdfInstallment({ data, buroYear, interest })
    );
    return html;
  };

  const getHtmlStatus = () => {
    const html = ReactDOMServer.renderToStaticMarkup(PdfStatus());
    return html;
  };

  return (
    <React.Fragment>
      <Document>
        <Page size="A4" style={stylesDocument.page}>
          <PdfDocument index={index} letter_id={letter_id} row={data} />
        </Page>
        <Page size="A4" style={stylesInstallment.page}>
          <View>
            <Html>{getHtmlInstallment()}</Html>
          </View>
        </Page>
        <Page size="A4" style={stylesDocument.page}>
          <View>
            <Html>{getHtmlStatus()}</Html>
          </View>
        </Page>
      </Document>
    </React.Fragment>
  );
}

export default PdfBuroYear;
